export default __webpack_public_path__ + "static/media/Events.45c3d705.svg";